module.exports = __webpack_public_path__ + "static/media/bg-bottom.86bf1c98.svg";